/**
 * Token 操作工具 - 仅供 store/modules/user.js 内部使用
 * 外部请勿直接调用，统一通过 store.getters.token 和 store.dispatch 操作
 */
import Cookies from 'js-cookie'

const TokenKey = 'bigScreenToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
